<i18n>
{
  "en": {
    "label": {
      "work": "Candidate work",
      "uploadData": "Upload Data",
      "uploadDataSub": "Please upload each file",
      "inputAddinfo": "Input addtional info",
      "done": "Completed",
      "status": "Status",
      "failed": "Postponed",
      "declined": "Declined",
      "dueDate": "Due to",
      "newestNgSubmission": "NG information of the latest submission",
      "originalData": "Identification data",
      "hiResData": "High Resolution data",
      "uploadHistory": "History (click to open row)",
      "id": "ID",
      "checkResult": "Check result:",
      "userComment": "Your comment",
      "submissions": "File you submit",
      "additionalNgReason": "Note",
      "nowChecking": "Now checking..",
      "checkingOk": "OK",
      "checkingNg": "NG",
      "checkingNone": "-",
      "dataType": "Data type",
      "ngReason": "Reject reason",
      "submissionDate": "Submit date",
      "editComment": "Edit Comment",
      "addImage": "Add Data",
      "close": "Close"
    },
    "message": {
      "waitNextStep": "Please wait for the next step.",
      "pleaseInputAddinfo": "Please enter additional information from the form below.",
      "waitDataCheck": "We are checking the data you entered.",
      "autoSkipWaitDataCheck": "The data is being checked because the input deadline has passed.",
      "awardType": "Award: ",
      "waitProductShipping": "We are preparing to send out prizes. just a moment please.",
      "waitProductShippingCaution1": "*We plan to ship according to the schedule described in the application guidelines, but please note that the shipping time may change depending on the preparation status. (It may take time to arrange prizes.)",
      "waitProductShippingCaution2": "*If you would like to change the shipping address for the prizes registered as additional information due to reasons such as moving house, please contact us from the inquiry described at the bottom of the campaign application guidelines. Please note that if the prize has already been shipped by the time you contact us, we will not be able to make changes.",
      "done": "All procedures completed 🎉",
      "doneSub": "It becomes winning decision. Thank you very much for your cooperation.",
      "doneSub-1": "If the campaign involves shipping prizes, prizes will be shipped. Please wait for a while.",
      "doneSub-2": "Since we were unable to confirm your submission by the specified deadline, we will display your work without the additional information.",
      "doneSub-3": "Since we were unable to confirm your submission by the specified deadline, we have cancelled the delivery of the prize. ",
      "automaticFailure": "I am sorry to say that the winning of this work has been postponed. Thank you for your understanding.",
      "failed": "I am sorry to say that the winning of this work has been postponed. Thank you for your understanding.",
      "declined": "Thank you for contacting us to decline the award. Your request has been accepted.",
      "failedWithThanks": "We hope you will continue to participate in our campaign in the future. Thank you for your cooperation in the procedure.",
      "statusNotice": "The procedure has not been completed. Please register {dataType}.",
      "statusNoticeConjunction": " and ",
      "defeatReason": "Reason for loss",
      "declinedReason": "Reason for declining",
      "plsHandleTil" : "Please respond by the above date."
    },
    "topMessage": {
      "uploadOriginal": "Please upload data for identity verification.",
      "uploadHires": "Please upload high resolution data.",
      "additionalInfo": "Please enter additional information.",
      "plsWaitCheck": "Data confirmation is in progress. Please wait for a while.",
      "longHolidayCheck": "Please note that it will take time for us to confirm your order during long holidays.",
      "autoSkipWaitCheck": "Skipped automatically the high resolution data was not submitted within expiration.　Please wait for a while.",
      "plsWaitNext": "Please wait for the next step.",
      "plsWaitInfoCheck": "We have confirmed the information you entered. Please wait for a while.",
      "autoSkipAdditionalInfo": "Skipped automatically due to expiration.　Please wait for a while.",
      "plsWaitShipping": "We are preparing to ship prizes. Please wait for a while.",
      "done": "Completed",
      "plsInputWorkCheckList": "Please answer the work confirmation questions."
    },
    "table": {
      "header": {
        "id" : "ID",
        "type": "High Resolution/Identity Verification",
        "createdAt": "Submit Date"
      }
    }
  },
  "ja": {
    "label": {
      "work": "入選候補作品",
      "uploadData": "データアップロード",
      "uploadDataSub": "各ファイルのアップロードをお願いします",
      "inputAddinfo": "追加情報の入力",
      "done": "完了",
      "status": "ステータス",
      "failed": "落選",
      "declined": "辞退",
      "dueDate": "対応期限",
      "newestNgSubmission": "最新の提出のNG情報",
      "originalData": "本人確認データ",
      "hiResData": "高解像度データ",
      "uploadHistory": "アップロード履歴（クリックで詳細を開く）",
      "id": "ID",
      "checkResult": "チェック結果：",
      "userComment": "提出時のコメント",
      "submissions": "提出ファイル",
      "additionalNgReason": "補足メッセージ",
      "nowChecking": "現在確認中",
      "checkingOk": "OK",
      "checkingNg": "NG",
      "checkingNone": "ー",
      "dataType": "データ種類",
      "ngReason": "NG理由",
      "submissionDate": "提出日",
      "editComment": "コメント編集",
      "addImage": "データ追加",
      "close": "閉じる"
    },
    "message": {
      "waitNextStep": "次のステップまでもうしばらくお待ちください。",
      "pleaseInputAddinfo": "下記フォームから追加情報をご入力ください。",
      "waitDataCheck": "入力いただいたデータを確認中です。もうしばらくお待ちください。",
      "autoSkipWaitDataCheck": "追加情報入力期限を過ぎたためデータを確認中です。もうしばらくお待ちください。",
      "awardType": "賞: ",
      "waitProductShipping": "賞品の発送準備を行っております。もうしばらくお待ちください。",
      "waitProductShippingCaution1": "※募集要項に記載のスケジュールに沿って発送を予定していますが、準備状況により発送時期が前後する場合がございますこと、予めご了承ください。（賞品の手配にお時間をいただく場合がございます）",
      "waitProductShippingCaution2": "※引越し等のご都合により、追加情報としてご登録いただいた賞品送付先を変更したい場合はキャンペーン募集要項の下部に記載しているお問い合わせよりご連絡をお願いいたします。なおご連絡いただいた時点ですでに賞品発送が完了している場合は変更対応ができませんこと、ご容赦ください。",
      "done": "すべての手続が完了しました！",
      "doneSub": "おめでとうございます。受賞確定となります。ご協力頂き誠にありがとうございました。",
      "doneSub-1": "賞品を伴う受賞の場合、賞品は発送済みになります。まだ届いていない場合はもうしばらくお待ちください。",
      "doneSub-2": "追加情報の入力を期限内にしていただけなかったため、作品を展示/掲載する際は情報なしでの展示をさせていただきます。",
      "doneSub-3": "追加情報の入力を期限内にしていただけなかったため、商品の授与は見送りとさせていただきました。",
      "automaticFailure": "誠に残念ながら、期限以内に対応いただけなかったため、当作品の受賞は見送りとさせていただきました。ご理解いただけますよう、お願い申し上げます。",
      "failed": " 誠に残念ながら、当作品が本人の作品と証明していただくことができなかったため、受賞は見送りとさせていただきました。ご理解いただけますよう、お願い申し上げます。",
      "declined": " 「受賞ご辞退」のご連絡ありがとうございます。受け付けが完了いたしました。",
      "failedWithThanks": "今後とも、弊社のキャンペーンにご参加いただけますと幸いです。この度は手続きにご協力頂き、誠にありがとうございました。",
      "statusNotice": "手続きが完了していません。{dataType}を登録してください。",
      "statusNoticeConjunction": "および、",
      "defeatReason": "落選理由",
      "declinedReason": "辞退理由",
      "plsHandleTil" : "までにご対応お願いします"
    },
    "topMessage": {
      "uploadOriginal": "本人確認データをアップロードしてください。",
      "uploadHires": "高解像度データをアップロードしてください。",
      "additionalInfo": "追加情報を入力してください。",
      "plsWaitCheck": "データを受け付けました。事務局にてデータを確認いたしますので、今しばらくお待ちください。なお、データの確認には3営業日程度（土日祝日を除く）かかることがございますので、ご了承ください。（※確認完了後、データの再提出や「追加情報の入力」をお願いする場合は、事務局よりメールにてご連絡いたします。※また、追加のご対応をお願いする場合は、新しくご対応期日を設定いたします。）",
      "longHolidayCheck": "長期連休中（年末年始/ゴールデンウィーク期間など）は確認作業にお時間をいただきますこと、あらかじめご了承ください。",
      "autoSkipWaitCheck": "高解象度データが期限内に提出されなかったため、自動的にデータ確認中にステータスを変更しています。事務局で確認の上、後日メールにてご連絡します。",
      "plsWaitNext": "データを受け付けました。事務局で確認の上、後日メールにてご連絡いたします。",
      "plsWaitInfoCheck": "追加情報を受け付けました。事務局で確認の上、後日メールにてご連絡いたします。",
      "autoSkipAdditionalInfo": "追加情報入力期限を過ぎました。事務局で確認の上、後日メールにてご連絡いたします。",
      "plsWaitShipping": "事務局で賞品の発送準備を行っております。完了次第メールにてご連絡いたします。",
      "done": "すべての手続きは完了です。",
      "plsInputWorkCheckList": "作品確認事項にご回答ください。"
    },
    "table": {
      "header": {
        "id" : "ID",
        "type": "高解像度/本人確認",
        "createdAt": "アップロード日"
      }
    }
  }
}
</i18n>

<template>
  <v-stepper v-if="work.status !== EnumStatuses.Defeat" :value="step" vertical>

    <div style="width: 100%; background-color: #EEF0F2;">
      <v-container row wrap>
        <v-layout column>
          <v-flex xs12 sm12 md3 lg3 style="text-align: center; margin-bottom: 16px;">
            <span class="work-title font-weight-bold">{{
              $t('label.work')
            }}</span>
          </v-flex>

          <v-flex
            xs12
            sm12
            class="text-xs-center text-sm-center text-md-center text-lg-center"
          >
            <v-img
              :src="work.mediaUrl"
              class="work-image"
              max-height="300"
              contain
              @click="popupImage"
            ></v-img>

            <v-dialog max-width="700" max-height="700" v-model="imageBox">
              <v-container>
                <v-layout justify-center align-center>
                  <v-flex>
                    <v-img
                      :src="work.mediaUrl"
                      v-if="imageBox === true"
                      max-height="1000"
                      contain
                      max-width="700"
                    ></v-img>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-dialog>
          </v-flex>
          <v-flex xs12 sm12 md3 lg3></v-flex>
        </v-layout>
      </v-container>
    </div>

    <br />
    <br />
    <div class="font-weight-bold" :class="messageClass" style="padding: 0px 10px;">
      <span v-for="(msg, index) in topMessages" :key="index">
        <p class="pl-2 pr-2 pt-0" style='text-align:left'>
          <v-icon left color="error" class="mr-1">warning</v-icon>
          <span v-if="isUploadMessage(msg)"><a :href="'#uploadArea' + work.id" style="text-decoration: none; color: black;">{{ msg }}</a></span>
          <span v-else>{{ msg }}</span>
        </p>
      </span>
    </div>
    <br />

    <hr v-if="work.workCheckLists && work.workCheckLists.length > 0" color="#EEF0F2" />
    <WorkCheckListForm v-if="work.workCheckLists && work.workCheckLists.length > 0" v-model="work"></WorkCheckListForm>

    <hr color="#EEF0F2" />

    <div :id="'uploadArea' + work.id"></div>
    <v-stepper-step
      :complete="step > 1"
      :color="step > 1 ? 'green' : color.step.now"
      step="1"
    >
      <span :class="step === 1 ? 'bold' : ''">{{
        $t('label.uploadData')
      }}<a :href="'/cp/' + getCampaignCode() + '/me/help#category1'" target="_blank" style="text-decoration: none;"><v-icon class="ml-1 hover-icon" slot="activator" dark color="primary">help_outline</v-icon></a></span>
      <small v-if="step === 1">{{ $t('label.uploadDataSub') }}</small>
    </v-stepper-step>

    <v-stepper-content :class="isNarrow ? 'narrow' : ''" step="1">
      <!-- ダイアログフォームたち -->
      <v-dialog v-model="originalDialog">
        <div style="overflow-x: hidden;">
          <div style="background-color: white; text-align: right;">
            <v-btn
              small
              color="primary"
              @click="originalDialog = false"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <SubmissionForm
            :workId="work.id"
            :submissionType="EnumSubmissionType.Original"
          ></SubmissionForm>
        </div>
      </v-dialog>

      <v-dialog v-model="hiResDialog">
        <div style="overflow-x: hidden;">
          <div style="background-color: white; text-align: right;">
            <v-btn
              small
              color="primary"
              @click="hiResDialog = false"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <SubmissionForm
            :workId="work.id"
            :submissionType="EnumSubmissionType.HiRes"
          ></SubmissionForm>
        </div>
      </v-dialog>

      <v-dialog v-model="originalUpdateCommentDialog">
        <div style="overflow-x: hidden;">
          <div style="background-color: white; text-align: right;">
            <v-btn
              small
              color="primary"
              @click="originalUpdateCommentDialog = false"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <SubmissionUpdateCommentForm :submission="submissionToUpdate" />
        </div>
      </v-dialog>

      <v-dialog v-model="originalUpdateDialog">
        <div style="overflow-x: hidden;">
          <div style="background-color: white; text-align: right;">
            <v-btn
              small
              color="primary"
              @click="originalUpdateDialog = false"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <SubmissionUpdateForm :submission="submissionToUpdate" />
        </div>
      </v-dialog>

      <v-card
        v-if="work.status !== EnumStatuses.DataReceived"
        class="mb-3 elevation-0"
        color="grey lighten-4"
        style="padding: 8px;"
      >
        <div>
          <v-container grid-list-xl class="mx-0">
            <v-layout wrap>
              <v-flex xs12 sm12 md6 lg6 xl6>
                <div>
                  <span style="color: grey; vertical-align:middle;">{{ $t('label.status') }}</span>：
                  <span
                    class="pb-3"
                    style="font-size: 1.5rem; font-weight: bold; color: red; vertical-align:middle;"
                  >
                    {{ getStatusName(work.status) }}
                  </span>
                  <br />
                  <span v-if="this.needOriginal || this.needHiRes"
                    id="statusNotice" ref="statusNotice" style="font-size: 1rem; font-weight: bold; color: red; vertical-align:middle;"
                    :class="[
                      this.isBottomNoticeAnimationStart ? 'animationStart' : '',
                      this.isBottomNoticeAnimationEnd ? 'animationEnd' : '',
                    ]"
                  >
                    {{
                      $t('message.statusNotice', {
                        dataType:
                          (this.needOriginal ? $t('label.originalData') : '') +
                          ((this.needOriginal && this.needHiRes) ? $t('message.statusNoticeConjunction') : '') +
                          (this.needHiRes ? $t('label.hiResData') : '')
                      })
                    }}
                  </span>
                </div>
              </v-flex>

              <v-flex
                v-if="work.status === EnumStatuses.WaitingDataSubmission"
                xs12
                sm12
                md6
                lg6
                xl6
              >
                <div>
                  <span style="color: red">{{ $t('label.dueDate') }}</span>
                  <a :href="'/cp/' + getCampaignCode() + '/me/help#category1'" target="_blank" style="text-decoration: none;"><v-icon class="ml-1 hover-icon" slot="activator" dark color="primary">help_outline</v-icon></a>
                  <br />
                  <span style="color: red" class="subheading">
                    <u
                      ><b>{{ work.statusUpdateDueTo | visibleDate }}</b></u
                    >
                  </span>
                  <span class="ml-1" style="color: grey">{{
                    $t('message.plsHandleTil')
                  }}</span>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </div>

        <v-card-text
          v-if="submissions.length > 0 && (needHiRes && lastNgHiResSubmission || needOriginal && lastNgOriginalSubmission)"
          style="padding: 3px;"
          color="green lighten-3"
        >
          <br />

          <LastNgSubmissionInfo
            v-if="needHiRes && lastNgHiResSubmission"
            :title="
              $t('label.newestNgSubmission') +
                '（' +
                $t('label.hiResData') +
                '）'
            "
            :submission="lastNgHiResSubmission"
          ></LastNgSubmissionInfo>

          <br />

          <LastNgSubmissionInfo
            v-if="needOriginal && lastNgOriginalSubmission"
            :title="
              $t('label.newestNgSubmission') +
                '（' +
                $t('label.originalData') +
                '）'
            "
            :submission="lastNgOriginalSubmission"
          ></LastNgSubmissionInfo>
        </v-card-text>

        <div class="pt-3" style="text-align: center;">
          <v-btn
            v-if="needOriginal"
            color="primary"
            @click="originalDialog = true"
          >
            <v-icon class="btn-icon force-color-green" dark>add</v-icon
            >{{ $t('label.originalData') }}
          </v-btn>

          <v-btn v-if="needHiRes" color="primary" @click="hiResDialog = true">
            <v-icon class="btn-icon" dark>add</v-icon
            >{{ $t('label.hiResData') }}
          </v-btn>

        </div>

        <div v-if="submissions.length > 0">
          <br />
          <v-divider></v-divider>

          <v-toolbar flat dense color="#f5f5f5">
            <b>{{ $t('label.uploadHistory') }}</b>
          </v-toolbar>

          <v-data-table
            :items="submissions"
            :headers="table.submissions.headers"
            :rows-per-page-items="[5]"
            :pagination.sync="table.pagination"
            class="elevation-1"
            expand
          >
            <template slot="items" slot-scope="props">
              <tr @click.stop="props.expanded = !props.expanded">
                <td class="text-xs-center">
                  {{ props.item.createdAt | visibleDate }}
                </td>
                <td class="text-xs-center">
                  {{ getEnumStr('submissionType', props.item.submissionType) }}
                </td>
                <td class="text-xs-right">
                  <!-- submission編集フォーム -->
                  <!-- 業務ロジック上、編集できるsubmissionはtypeにつき1つしか存在しないことが前提 -->
                  <span v-if="props.item.isDealt === false">
                    <v-btn @click.stop="openUpdateCommentForm(props.item)"
                      small
                      color="primary"
                    >
                      {{ $t('label.editComment') }}
                    </v-btn>
                    <v-btn @click.stop="openUpdateForm(props.item)"
                      small
                      color="primary"
                    >
                      {{ $t('label.addImage') }}
                    </v-btn>
                  </span>
                  <!-- expandボタン -->
                  <v-btn @click.stop="props.expanded = !props.expanded" icon>
                    <v-icon>{{
                      props.expanded
                        ? 'keyboard_arrow_up'
                        : 'keyboard_arrow_down'
                    }}</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>

            <template slot="expand" slot-scope="props">
              <v-card class="elevation-2">
                <v-card-text>
                  <v-card class="elevation-0">
                    <v-card-text class="pt-0">
                      <div
                        v-if="props.item.addedNgReason && props.item.isDealt"
                      >
                        <span class="subheading"
                          >{{ $t('label.additionalNgReason') }}
                        </span>
                        <div class="div ng-submission-card">
                          <span style="white-space: pre-wrap;">{{
                            props.item.addedNgReason
                          }}</span>
                        </div>
                      </div>

                      <span class="subheading">
                        {{ $t('label.userComment') }}
                      </span>
                      <v-card class="blockquote message-area">
                        <span style="white-space: pre-wrap;">{{ props.item.userComment }}</span>
                      </v-card>
                      <br />

                      <span class="subheading">
                        {{ $t('label.submissions') }}
                      </span>
                      <div
                        v-for="file in props.item.submissionFiles"
                        :key="file.id"
                        style="margin-top: 4px;"
                      >
                        <v-card class="elevation-1">
                          <v-card-title>
                            <h3>
                              {{ $t('label.id') }}:{{ file.id }}
                              {{ file.fileName }}
                            </h3>
                            <v-spacer></v-spacer>
                            <v-chip label color="" text-color="black">
                              <template v-if="!props.item.isDealt">
                                <span>{{ $t('label.nowChecking') }}</span>
                              </template>
                              <template v-else-if="file.isValid === true">
                                <span>{{ $t('label.checkResult') }}</span>
                                <span style="color: green;">{{ $t('label.checkingOk') }}</span>
                              </template>
                              <template v-else-if="file.isValid === false">
                                <span>{{ $t('label.checkResult') }}</span>
                                <span style="color: red;">{{ $t('label.checkingNg') }}</span>
                              </template>
                              <template v-else>
                                <span>{{ $t('label.checkResult') }}</span>
                                <span>{{ $t('label.checkingNone') }}</span>
                              </template>
                            </v-chip>
                          </v-card-title>
                          <v-card-text class="pt-0">
                            <span class="body-2"
                              >【{{ $t('label.dataType') }}】{{
                                getEnumStr(
                                  'submissionFileType',
                                  file.submissionFileType
                                )
                              }}</span
                            >
                            <div
                              v-if="
                                props.item.isDealt === true &&
                                  file.isValid === false
                              "
                            >
                              <br />
                              <div style="display: flex">
                                <div class="body-2">
                                  【{{ $t('label.ngReason') }}】
                                </div>
                                <div style="white-space: pre-wrap; color: red;">{{
                                  file.ngReason
                                }}</div>
                              </div>
                            </div>
                            <br /><span class="body-2"
                              >【{{ $t('label.submissionDate') }}】{{
                                file.createdAt | visibleDate
                              }}</span
                            >
                          </v-card-text>
                        </v-card>
                        <v-divider></v-divider>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-card-text>
              </v-card>
            </template>
          </v-data-table>
        </div>
      </v-card>

      <v-card
        v-if="work.status === EnumStatuses.DataReceived"
        class="mb-3 elevation-0"
        color="grey lighten-4"
        style="padding: 15px;"
      >
        <v-icon>info</v-icon>{{ $t('message.waitNextStep') }}
      </v-card>
    </v-stepper-content>

    <v-stepper-step
      :complete="
        step > 2 || work.status === EnumStatuses.WaitingProductShipping
      "
      :color="
        step > 2 || work.status === EnumStatuses.WaitingProductShipping
          ? 'green'
          : color.step.now
      "
      step="2"
    >
      <span :class="(step === 2 && work.status !== EnumStatuses.WaitingProductShipping) ? 'bold' : ''">{{
        $t('label.inputAddinfo')
      }}<a :href="'/cp/' + getCampaignCode() + '/me/help#category4'" target="_blank" style="text-decoration: none;"><v-icon class="ml-1 hover-icon" slot="activator" dark color="primary">help_outline</v-icon></a></span>
      <small v-if="step === 2 && work.status === EnumStatuses.WaitingWorkInformationInput">{{ $t('message.pleaseInputAddinfo') }}</small>
    </v-stepper-step>
    <v-stepper-content
      :class="isNarrow ? 'narrow' : ''"
      step="2"
      v-if="step === 2"
    >
      <v-card
        v-if="work.status === EnumStatuses.WaitingWorkInformationInput"
        class="from-area"
        color="grey lighten-4"
      >
        <AttachedItemsForm v-model="work"></AttachedItemsForm>
      </v-card>
      <v-card
        v-else-if="work.status === EnumStatuses.WaitingProductShipping"
        style="padding: 20px 20px;"
      >
        <div style="display: flex; flex-direction: row;">
          <v-icon>info</v-icon><span style="margin-left: 8px;">{{ $t('message.waitProductShipping') }}</span>
        </div>
        <div style="display: flex; flex-direction: row;">
          <v-icon>info</v-icon><span style="margin-left: 8px; font-size: 1.5rem; font-weight: bold;">{{ $t('message.awardType') + this.awardName }}</span>
        </div>
        <div style="display: flex; flex-direction: row; margin-top: 30px;">
          <span style="margin-left: 32px;">{{ $t('message.waitProductShippingCaution1') }}</span>
        </div>
        <div style="display: flex; flex-direction: row;">
          <span style="margin-left: 32px;">{{ $t('message.waitProductShippingCaution2') }}</span>
        </div>
      </v-card>
      <v-card v-else style="padding: 24px 0px; padding-left: 32px;">
        <div style="display: flex; flex-direction: row;">
          <v-icon>info</v-icon>
          <span style="margin-left: 8px;"><template v-if="!this.isAdditionalInfoAutoSkip">{{ $t('message.waitDataCheck') }}</template>
          <template v-if="this.isAdditionalInfoAutoSkip">{{ $t('message.autoSkipWaitDataCheck') }}</template></span>
        </div>
        <div style="display: flex; flex-direction: row;">
          <v-icon>info</v-icon><span style="margin-left: 8px; font-size: 1.5rem; font-weight: bold;">{{ $t('message.awardType') + this.awardName }}</span>
        </div>
      </v-card>
    </v-stepper-content>

    <!--<v-stepper-step step="3">-->
    <v-stepper-step
            :complete="step === 3"
            :color="step === 3 ? 'green' : color.step.now"
            step="3"
    >
      {{ $t('label.done') }}
    </v-stepper-step>

    <v-stepper-content :class="isNarrow ? 'narrow' : ''" step="3">
      <v-card style="padding:0 15px 0 15px">
        <span style="font-size: 1.5rem; font-weight: bold;">{{ $t('message.awardType') + this.awardName }}</span><br />
        {{ $t('message.done') }}
        <br />
        <template v-if="work.isAttachedAnswersOk">
          {{ $t('message.doneSub-1') }}
        </template>
        <template v-else>
          <template v-if="existsPublishedItem()">
            {{ $t('message.doneSub-2') }}<br />
          </template>
          <template v-if="existsShippingItem()">
            {{ $t('message.doneSub-3') }}<br />
          </template>
        </template>
      </v-card>
    </v-stepper-content>
  </v-stepper>
  <div v-else>
    <span class="title font-weight-bold">
      <p class="pl-3 pt-3">
        {{ $t('label.status') }}：<span v-if="work.isDeclined">{{ $t('label.declined') }}</span><span v-else>{{ $t('label.failed') }}</span>
      </p>
    </span>
    <div style="width: 100%; background-color: #EEF0F2;">
      <v-container>
        <v-layout style="flex-direction: column;">
          <template v-if="isAutomaticFailure">
            {{ $t('message.automaticFailure') }}
          </template>
          <template v-else>
            <span v-if="work.isDeclined">{{ $t('message.declined') }}</span>
            <v-card style="margin-top: 16px; margin-bottom: 16px; padding: 16px;">
              <div style="font-weight: bold; margin-bottom: 16px; color: red;">
                <span v-if="work.isDeclined">{{ $t('message.declinedReason') }}</span><span v-else>{{ $t('message.defeatReason') }}</span>
              </div>
              <span style="white-space: pre-wrap;">{{
                this.work.defeatReason
              }}</span>
            </v-card>
          </template>
          <br />
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import { dateFormatter } from '@/utils';
import SubmissionForm from '@/components/molecules/SubmissionForm.vue';
import SubmissionUpdateForm from '@/components/molecules/SubmissionUpdateForm.vue';
import SubmissionUpdateCommentForm from '@/components/molecules/SubmissionUpdateCommentForm.vue';
import AttachedItemsForm from '@/components/molecules/AttachedItemsForm.vue';
import WorkCheckListForm from '@/components/molecules/WorkCheckListForm.vue';
import LastNgSubmissionInfo from '@/components/molecules/LastNgSubmissionInfo.vue';
import { Me } from '@/api';
import { EnumSubmissionType, EnumPurposeTypes, EnumWorkCheckListResponseStatus } from '@/enum/enum.js';
import StorageManager from '@/utils/StorageManager';

export default {
  components: {
    SubmissionForm,
    SubmissionUpdateCommentForm,
    SubmissionUpdateForm,
    AttachedItemsForm,
    WorkCheckListForm,
    LastNgSubmissionInfo
  },
  props: {
    work: {}
  },
  data() {
    //ステータスコード
    const EnumStatuses = {
      Defeat: 1,
      AdvanceWinningCandidate: 2,
      WaitingInitialContact: 3,
      WaitingDataSubmission: 4,
      WaitingDataCheck: 5,
      DataReceived: 6,
      WaitingWorkInformationInput: 7,
      WaitingWorkInformationCheck: 8,
      WaitingProductShipping: 9,
      Completed: 10
    };
    const EnumUserType = {
      Operator: 1,
      Applicant: 2,
      System: 3
    };
    //MyPageステッパーコントロールのステップ情報
    const EnumSteps = {
      Upload: 1,
      Form: 2,
      Done: 3,
      Rjected: 4
    };

    return {
      EnumStatuses,
      EnumUserType,
      EnumSteps,
      EnumSubmissionType,
      EnumPurposeTypes,
      statusMapper: {
        [EnumStatuses.Defeat]: EnumSteps.Upload,
        [EnumStatuses.AdvanceWinningCandidate]: EnumSteps.Upload,
        [EnumStatuses.WaitingInitialContact]: EnumSteps.Upload,
        [EnumStatuses.WaitingDataSubmission]: EnumSteps.Upload,
        [EnumStatuses.WaitingDataCheck]: EnumSteps.Upload,
        [EnumStatuses.DataReceived]: EnumSteps.Upload,
        [EnumStatuses.WaitingWorkInformationInput]: EnumSteps.Form,
        [EnumStatuses.WaitingWorkInformationCheck]: EnumSteps.Form,
        [EnumStatuses.WaitingProductShipping]: EnumSteps.Form,
        [EnumStatuses.Completed]: EnumSteps.Done
      },
      user: {},
      active: null, //現在選択されているworksの配列の番号
      originalDialog: false,
      hiResDialog: false,
      imageBox: false,
      isOpenIgDialog: false,
      submissions: [],
      worksAttachedItems: {},
      color: {
        step: {
          now: 'primary',
          complete: 'green'
        }
      },
      originalUpdateCommentDialog: false,
      originalUpdateDialog: false,
      hiresUpdateDialog: false,
      submissionToUpdate: null,
      table: {
        submissions: {
          headers: [
            {
              text: this.$t('table.header.createdAt'),
              align: 'center',
              value: 'createdAt',
              sortable: false
            },
            {
              text: this.$t('table.header.type'),
              align: 'center',
              value: 'type',
              sortable: false
            },
            { text: '', align: 'center', value: '' }
          ]
        },
        pagination: {
          sortBy: 'createdAt',
          descending: true
        }
      },
      isAutomaticFailure: false,
      isHighresolutionDataSkip: false,
      isAdditionalInfoAutoSkip: false,
      awardName: '',
      isBottomNoticeAnimationStart: false,
      isBottomNoticeAnimationEnd: false
    };
  },
  methods: {
    scrollHandler() {
      const rect = this.$refs.statusNotice.getBoundingClientRect();
      if (rect.y >= 0 && rect.y <= window.innerHeight) {
        if (!this.isBottomNoticeAnimationStart && !this.isBottomNoticeAnimationEnd) {
          this.isBottomNoticeAnimationStart = true;
          setTimeout(() => {
            this.isBottomNoticeAnimationEnd = true;
          }, 500);
        }
      } else {
        this.isBottomNoticeAnimationStart = false;
        this.isBottomNoticeAnimationEnd = false;
      }
    },
    getStatusName(status) {
      let statusName = this.getEnumStr('workStatus', status);
      if (statusName && status == this.EnumStatuses.WaitingDataSubmission && this.work.metrics.dataSubmissionsCount > 0) {
        statusName = statusName.replace('データ提出待ち', 'データ再提出待ち');
      }
      return statusName;
    },
    openUpdateCommentForm(item) {
      this.submissionToUpdate = Object.assign({}, item);
      this.originalUpdateCommentDialog = true;
    },
    openUpdateForm(item) {
      this.submissionToUpdate = Object.assign({}, item);
      this.originalUpdateDialog = true;
    },
    popupImage() {
      this.imageBox = true;
    },
    updateSubmission(id) {
      alert(id);
      this.updateDialog = true;
    },
    existsPublishedItem() {
      if (!this.worksAttachedItems[this.work.id]) return false;
      for (let attachedItem of this.worksAttachedItems[this.work.id]) {
        if (attachedItem.purpose == this.EnumPurposeTypes.Published) return true;
      }
      return false;
    },
    existsShippingItem() {
      if (!this.worksAttachedItems[this.work.id]) return false;
      for (let attachedItem of this.worksAttachedItems[this.work.id]) {
        if (attachedItem.purpose == this.EnumPurposeTypes.Shipping) return true;
      }
      return false;
    },
    /**
     * EnumのTypeとCodeとlocaleからEnumの文字列を返却
     * @param String type EnumのType
     * @param Integer code EnumのCode
     */
    getEnumStr(type, code) {
      return this.$store.getters.getEnumByCode({ type, code });
    },
    getCurrentSubmission(submissionType) {
      for (let item of this.submissions) {
        if (item.submissionType == submissionType && item.isDealt == false) {
          return item;
        }
      }
    },
    getCampaignCode: () => {
      return StorageManager.getItem('CAMPAIGN_CODE_SESSION_KEY');
    },
    // 設問全てに回答済みの場合trueを返す
    // 回答内容にエラーが出ているかどうかは不問
    allAnswered() {
      for (const workCheckList of this.work.workCheckLists) {
        if (
          !workCheckList.workCheckListAnswer ||
          workCheckList.workCheckListAnswer.responseStatus !=
            EnumWorkCheckListResponseStatus.Answerd
        ) {
          return false;
        }
      }
      return true;
    },
    // アップロードメッセージなのか判定する
    // アップロードを促すtopMessagesへアンカーリンクを設置するための処理
    isUploadMessage(message) {
      if (message == this.$t('topMessage.uploadOriginal')) {
        return true;
      }
      if (message == this.$t('topMessage.uploadHires')) {
        return true;
      }
      return false;
    }
  },
  filters: {
    visibleDate: date => {
      // TODO 英語対応
      return dateFormatter.formatWithLocale(date);
    }
  },
  computed: {
    isNarrow: function() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    messageClass: function() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return 'title';
      }
      return '';
    },
    /**
     * convert status code to stepper's value
     * @param Integer status
     * @return String
     */
    step() {
      return this.statusMapper[this.work.status];
    },
    topMessages: function() {
      let messages = [];
      if (!this.allAnswered()) {
        messages.push(this.$t('topMessage.plsInputWorkCheckList'));
      }
      if (this.step === 1) {
        if (this.work.status === this.EnumStatuses.WaitingDataCheck) {
          if (this.isHighresolutionDataSkip) {
            messages.push(this.$t('topMessage.autoSkipWaitCheck'));
            return messages;
          } else {
            messages.push(this.$t('topMessage.plsWaitCheck'));
            messages.push(this.$t('topMessage.longHolidayCheck'));
            return messages;
          }
        }

        if (this.work.status === this.EnumStatuses.DataReceived) {
          messages.push(this.$t('topMessage.plsWaitNext'));
          return messages;
        }

        if (this.needOriginal) {
          messages.push(this.$t('topMessage.uploadOriginal'));
        }
        if (this.needHiRes) {
          messages.push(this.$t('topMessage.uploadHires'));
        }
      } else if (this.step === 2) {
        if (
          this.work.status === this.EnumStatuses.WaitingWorkInformationInput
        ) {
          messages.push(this.$t('topMessage.additionalInfo'));
          return messages;
        }

        if (
          this.work.status === this.EnumStatuses.WaitingWorkInformationCheck
        ) {
          if (this.isAdditionalInfoAutoSkip) {
            messages.push(this.$t('topMessage.autoSkipAdditionalInfo'));
          } else {
            messages.push(this.$t('topMessage.plsWaitInfoCheck'));
            messages.push(this.$t('topMessage.longHolidayCheck'));
          }
          return messages;
        }

        if (this.work.status === this.EnumStatuses.WaitingProductShipping) {
          messages.push(this.$t('topMessage.plsWaitShipping'));
          return messages;
        }
      } else if (this.step === 3) {
        messages.push(this.$t('topMessage.done'));
      }
      return messages;
    },
    lastNgOriginalSubmission: function() {
      const sortedSubmissions = this.submissions.concat();
      sortedSubmissions.sort(function(a, b) {
        return a.id > b.id ? 1 : -1;//idの昇順にソート
      })
      for (let i = sortedSubmissions.length - 1; i >= 0; i--) {
        if (
          sortedSubmissions[i].submissionType ===
            this.EnumSubmissionType.Original &&
          sortedSubmissions[i].isDealt
        ) {
          return sortedSubmissions[i];
        }
      }
      return false;
    },
    lastNgHiResSubmission: function() {
      const sortedSubmissions = this.submissions.concat();
      sortedSubmissions.sort(function(a, b) {
        return a.id > b.id ? 1 : -1;//idの昇順にソート
      })
      for (let i = sortedSubmissions.length - 1; i >= 0; i--) {
        if (
          sortedSubmissions[i].submissionType ===
            this.EnumSubmissionType.HiRes &&
          sortedSubmissions[i].isDealt
        ) {
          return sortedSubmissions[i];
        }
      }
      return false;
    },
    campaign: function() {
      return this.$store.getters.getCurrentCampaign;
    },
    needHiRes: function() {
      return this.work.canSubmitHiRes === true;
    },
    needOriginal: function() {
      return this.work.canSubmitOriginal === true;
    }
  },
  mounted: function() {
    Me.fetchSubmissions(this.work.id).then(submissions => {
      this.submissions = submissions;
    });

    //賞情報を取得
    if (this.work.awardId) {
      Me.fetchAwards(this.work.awardId, 'attached_items').then(async result => {
        //賞情報を設定
        this.awardName = result.name;
        this.$set(this.worksAttachedItems, this.work.id, result.attachedItems); //リアクティブな書き換え
      });
    }
    
    //自動追加情報スキップかどうかを判定
    //現在のステータスが「追加情報確認中」で、かつ、直前のステータス変更ログが「システム」だった場合、
    //自動追加情報スキップ（追加情報入力期限切れ）なので、その旨表示を行う
    if (this.work.status == this.EnumStatuses.WaitingWorkInformationCheck) {
      if(this.work.statusChangedLogs && this.work.statusChangedLogs.length > 0) {
        const scLog = this.work.statusChangedLogs[this.work.statusChangedLogs.length - 1];
        if (scLog.changedType == this.EnumUserType.System && scLog.statusChangedTo == this.EnumStatuses.WaitingWorkInformationCheck) {
          this.isAdditionalInfoAutoSkip = true;
        }
      }
    }

    //自動追加情報スキップかどうかを判定
    //現在のステータスが「データ確認中」かつ、「高解像度データ未確定」かつ、直前のステータス変更ログが「システム」だった場合、
    //自動高解像度データスキップ（高解像度データ入力期限切れ）なので、その旨表示を行う
    if (this.work.status == this.EnumStatuses.WaitingDataCheck) {
      if(this.work.statusChangedLogs && this.work.statusChangedLogs.length > 0) {
        const scLog = this.work.statusChangedLogs[this.work.statusChangedLogs.length - 1];
        if (scLog.changedType == this.EnumUserType.System && scLog.statusChangedTo == this.EnumStatuses.WaitingDataCheck && this.work.isHiResOk == false) {
          this.isHighresolutionDataSkip = true;
        }
      }
    }

    //自動落選かどうかを判定
    //現在のステータスが「落選」で、かつ、直前のステータス変更ログが「システム」だった場合、
    //自動落選なので、その旨表示を行う
    if (this.work.status == this.EnumStatuses.Defeat && this.work.statusChangedLogs && this.work.statusChangedLogs.length > 0) {
      const lastLog = this.work.statusChangedLogs[this.work.statusChangedLogs.length - 1 ];
      if (lastLog.statusChangedTo == this.EnumStatuses.Defeat && lastLog.changedType == this.EnumUserType.System) {
        this.isAutomaticFailure = true;
      }
    }

    // スクロールのハンドリング
    window.addEventListener("scroll", this.scrollHandler);
  }
};
</script>

<style scoped>
div.v-stepper__header {
  box-shadow: none;
  -webkit-box-shadow: none;
}
.v-stepper__content.narrow {
  border: none;
  margin: 0;
  padding: 0;
}
span.work-title {
  font-size: 1.5rem;
}
span.bold {
  font-weight: bold;
}
.work-image {
  transition: opacity 0.4s;
  width: 100%;
  height: 100%;
}
.work-image:hover {
  opacity: 0.6;
  cursor: pointer;;
}
.form-area {
  padding: 16px;
}
.message-area {
  word-break: break-word;
  margin-top: 4px;
  padding: 16px;
  font-size: small;
}
.ng-submission-card {
  background-color: white;
  margin-top: 1px;
  margin-bottom: 7px;
  padding: 10px;
  color: black;
  border: solid 3px red;
}
#statusNotice {
  transition: all 0.5s;
}
#statusNotice.animationStart {
  background-color: #ff7070;
}
#statusNotice.animationEnd {
  background-color: unset;
}

</style>
